<template>
  <m-dialog ref="dlg" @save="save" :title="model && model.id ? 'Ubah Jenis Kelas' : 'Tambah Jenis Kelas'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <FormGenerator autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation :field="schema" :model="model" :data="data" />
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import FormGenerator from "@/components/FormGenerator";

//@group Jenis Kelas
export default {
  name: "jenis-kelas-form",
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new",
  },
  components: {
    FormGenerator,
  },
  data() {
    return {
      step: 1,
      defJenisKelas: {
        agreement: null,
        cover: null,
        id_jenis_sertifikat: null,
        instansi_id: null,
        is_daring: null,
        is_pindah: null,
        is_selfenrol: null,
        is_sertifikat: null,
        is_show_course: null,
        is_show_nilai: null,
        keterangan: "",
        survei_slug: null,
        tag: "",
        url_survei: null,
      },
      disableForm: false,
      alert: ALERT_INFO,
      itemSeri: [],
      data: {
        itemSeri: [],
        itemTags: ["lms", "luring", "token", "extapp", "video"],
      },
      model: {},
      schema: [
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VAutocomplete",
          model: "instansi_id",
          items: "itemSeri",
          properties: {
            name: "seri",
            placeholder: "Semua Seri",
            label: "Pilih Seri",
            returnObject: true,
            itemText: "nama",
            itemValue: "id",
          },
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VTextField",
          model: "keterangan",
          properties: {
            name: "keterangan",
            placeholder: "Isikan Jenis",
            label: "Jenis",
          },
          validation: {
            dataVvname: "keterangan",
            dataVvAs: "Keterangan",
            vValidate: "required",
            errorMessages: "form.keterangan",
          },
        },
        {
          component: "VTextField",
          model: "cover",
          properties: {
            name: "cover",
            placeholder: "contoh: http://gb.storage.id/img/cover-jenis-kelas.png",
            label: "Tautan Cover Jenis Kelas",
          },
        },
        {
          grid: { cols: 12 },
          component: "VTextarea",
          model: "agreement",
          properties: {
            name: "agreement",
            placeholder: "Dengan mengikuti pelatihan ini maka...",
            label: "Agreement",
          },
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_sertifikat",
          properties: {
            label: "Menerbitkan Sertifikat",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          grid: { sm: 12 },
          component: "VTextField",
          model: "id_jenis_sertifikat",
          properties: {
            name: "jenis_sertifikat",
            placeholder: "Isikan ID Jenis Sertifikat",
            label: "ID Jenis Sertifikat",
          },
          vshow: false,
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VTextField",
          model: "survei_slug",
          properties: {
            name: "survei",
            placeholder: "Isikan Survey Slug",
            label: "Survey Slug",
          },
          vshow: false,
        },
        {
          grid: { cols: 12, md: 6, lg: 6 },
          component: "VTextField",
          model: "url_survei",
          properties: {
            name: "url_survei",
            placeholder: "Isikan Tautan Survey",
            label: "Tautan Survey",
          },
          vshow: false,
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_kuota",
          properties: {
            label: "Menerapkan Batasan Kuota",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_daring",
          properties: {
            label: "Sistem Pembelajaran",
          },
          pilihan: [
            {
              keterangan: "Daring",
              value: 1,
            },
            {
              keterangan: "Luring",
              value: 0,
            },
          ],
        },

        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_selfenrol",
          properties: {
            label: "Self Enroll",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_pindah",
          properties: {
            label: "Pindah",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_show_course",
          properties: {
            label: "Tampilkan Kelas",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          grid: { sm: 12, md: 6, lg: 6 },
          component: "VRadioGroup",
          model: "is_show_nilai",
          properties: {
            label: "Tampilkan Nilai",
          },
          pilihan: [
            {
              keterangan: "Iya",
              value: 1,
            },
            {
              keterangan: "Tidak",
              value: 0,
            },
          ],
        },
        {
          component: "VAutocomplete",
          items: "itemTags",
          model: "tag",
          properties: {
            placeholder: "Isikan Tag",
            label: "Pilih Tag",
          },
          validation: {
            dataVvName: "tag",
            dataVvAs: "Tag",
            vValidate: "required",
            errorMessages: "form.tag",
          },
        },
      ],
    };
  },

  methods: {
    // @vuese
    // Membuka dialog tambah atau edit jenis kelas, jika terdapat objek maka dialog yang terbuka adalah untuk edit dan jika objek kosong maka dialog yang terbuka adalah untuk tambah (baru) jenis kelas
    // @args objek jenis kelas
    open(obj) {
      this.loadSeri();

      if (obj) {
        this.model = { ...obj };
      } else {
        this.model = { ...this.defJenisKelas };
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // @vuese
    // Mengambil daftar seri untuk ditampilkan dalam pilihan seri
    loadSeri() {
      return this.$store
        .dispatch("instansi/get", this.instansi_id)
        .then((res) => {
          this.data.itemSeri = res;
          this.disableForm = false;
        })
        .catch((e) => e);
    },
    // @vuese
    // Menyimpan jenis kelas
    save() {
      this.jenis_kelas = this.model;
      this.$validator
        .validateAll("form")
        .then((res) => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          if (this.jenis_kelas.is_sertifikat == 0) {
            this.jenis_kelas.id_jenis_sertifikat = 0;
            this.jenis_kelas.survei_slug = "";
            this.jenis_kelas.url_survei = "";
          }
          return this.$store
            .dispatch("jenisKelas/form", {
              instansi_id: this.instansi_id,
              obj: this.jenis_kelas,
            })
            .then((res) => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch((e) => e);
        })
        .catch((e) => e);
    },
  },
  watch: {
    "model.is_sertifikat"(val) {
      let x = this.schema.findIndex((obj) => obj.model === "id_jenis_sertifikat");
      let y = this.schema.findIndex((obj) => obj.model === "survei_slug");
      let z = this.schema.findIndex((obj) => obj.model === "url_survei");
      if (val === 1) {
        this.schema[x].vshow = true;
        this.schema[y].vshow = true;
        this.schema[z].vshow = true;
      } else {
        this.schema[x].vshow = false;
        this.schema[y].vshow = false;
        this.schema[z].vshow = false;
      }
    },
  },
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
